
const ProjectsShowcase = () => {
  const projects = [
    {
      title: "ADNOC Onshore Scale Removal Project",
      location: "Bu Hasa Field, UAE",
      challenge: "Severe calcium carbonate scale buildup reducing production by 40%",
      solution: "Custom acid blend with scale inhibitor package",
      result: "95% scale removal, production restored to optimal levels",
      image: "https://public.readdy.ai/ai/img_res/104b99f12d0079348ac3c85726dfacea.jpg"
    },
    {
      title: "Enhanced Oil Recovery Implementation",
      location: "Zakum Field, UAE",
      challenge: "Declining reservoir pressure and oil recovery rates",
      solution: "Advanced surfactant flooding with polymer injection",
      result: "25% increase in oil recovery, extended field life by 8 years",
      image: "https://readdy.ai/api/search-image?query=Enhanced%20oil%20recovery%20chemical%20injection%20platform%20with%20Golden%20Black%20branding%2C%20advanced%20EOR%20technology%20in%20offshore%20oil%20field&width=500&height=300&seq=eor-project&orientation=landscape"
    },
    {
      title: "Matrix Stimulation Campaign",
      location: "Shah Gas Field, UAE",
      challenge: "Low permeability reducing gas production efficiency",
      solution: "Advanced acid fracturing with diverting agents",
      result: "300% improvement in gas flow rates, optimized production",
      image: "https://readdy.ai/api/search-image?query=Matrix%20stimulation%20operation%20with%20Golden%20Black%20equipment%2C%20advanced%20well%20intervention%20technology%20in%20gas%20field%20facility&width=500&height=300&seq=stimulation-project&orientation=landscape"
    },
    {
      title: "Reservoir Management Optimization",
      location: "Margham Field, UAE",
      challenge: "Complex reservoir heterogeneity affecting production",
      solution: "Integrated chemical and reservoir management approach",
      result: "40% improvement in sweep efficiency, maximized recovery",
      image: "https://readdy.ai/api/search-image?query=Reservoir%20management%20control%20center%20with%20Golden%20Black%20technology%2C%20advanced%20monitoring%20and%20optimization%20systems%20for%20oil%20field%20operations&width=500&height=300&seq=reservoir-project&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Project Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how Golden Black's expertise has transformed challenging oilfield operations 
            into success stories across the UAE and beyond.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={project.image}
                alt={project.title}
                className="w-full h-48 object-cover"
              />
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                <p className="text-teal-600 font-semibold mb-4 flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>
                  {project.location}
                </p>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Challenge:</h4>
                    <p className="text-gray-600 text-sm">{project.challenge}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Solution:</h4>
                    <p className="text-gray-600 text-sm">{project.solution}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Result:</h4>
                    <p className="text-teal-600 text-sm font-medium">{project.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Transform Your Operations?
            </h3>
            <p className="text-gray-600 mb-6">
              Join the growing list of successful projects powered by Golden Black's innovative chemical solutions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/consultation" 
                className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Consultation
              </a>
              <a 
                href="/contact" 
                className="border border-teal-600 text-teal-600 px-8 py-3 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact Our Experts
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsShowcase;
